import { render, staticRenderFns } from "./IDPFrom.vue?vue&type=template&id=c3802ae0"
import script from "./IDPFrom.vue?vue&type=script&lang=js"
export * from "./IDPFrom.vue?vue&type=script&lang=js"
import style0 from "./IDPFrom.vue?vue&type=style&index=0&id=c3802ae0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports